import { render, staticRenderFns } from "./narrative-sections-table.vue?vue&type=template&id=432a0d36"
import script from "./narrative-sections-table.vue?vue&type=script&lang=js"
export * from "./narrative-sections-table.vue?vue&type=script&lang=js"
import style0 from "./narrative-sections-table.vue?vue&type=style&index=0&id=432a0d36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports